import { get, post, put, del } from './apiClient';

export const manualSalesPerformanceService = {
  // Reusa o catálogo existente via endpoint dedicado (RBAC analytics.*)
  async searchProducts({ q = '', offset = 0, limit = 50 } = {}) {
    const params = { q, offset, limit };
    const response = await get('/api/v1/analytics/manual-sales-performance/products/simple', params);
    const list = response?.data || [];
    return list.map((p) => ({
      id: p.product_id,
      label: p.product_title || p.product_id
    }));
  },

  async listConfigs({ product_ids = [], q = undefined, offset = 0, limit = 50 } = {}) {
    const params = {
      product_ids: product_ids?.length ? product_ids : undefined,
      q: q || undefined,
      offset,
      limit
    };
    return await get('/api/v1/analytics/manual-sales-performance/configs', params);
  },

  async createConfig(payload) {
    return await post('/api/v1/analytics/manual-sales-performance/configs', payload);
  },

  async updateConfig(productId, payload) {
    return await put(`/api/v1/analytics/manual-sales-performance/configs/${encodeURIComponent(productId)}`, payload);
  },

  async deleteConfig(productId) {
    return await del(`/api/v1/analytics/manual-sales-performance/configs/${encodeURIComponent(productId)}`);
  },

  async getSeries({ product_ids = [], start_date = undefined, end_date = undefined, percent_min = undefined, percent_max = undefined, granularity = undefined } = {}) {
    const params = {
      product_ids: product_ids?.length ? product_ids : undefined,
      start_date,
      end_date,
      percent_min: typeof percent_min === 'number' ? percent_min : undefined,
      percent_max: typeof percent_max === 'number' ? percent_max : undefined,
      granularity: granularity || undefined
    };
    return await get('/api/v1/analytics/manual-sales-performance/series', params);
  },

  async getDefaultProduct() {
    return await get('/api/v1/analytics/manual-sales-performance/default-product');
  }
};
